"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMakeWithdrawal = void 0;
var keys_1 = require("../keys");
var react_1 = require("react");
var useMutation_1 = require("../useMutation");
var useMakeWithdrawal = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        path: keys_1.WITHDRAWAL_MAKE,
        keysUpdate: [keys_1.BALANCE, keys_1.PENDING_WITHDRAWALS],
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error;
    return (0, react_1.useMemo)(function () { return ({
        makeWithdrawal: mutate,
        isSubmitting: isSubmitting,
        error: error,
    }); }, [mutate, isSubmitting, error]);
};
exports.useMakeWithdrawal = useMakeWithdrawal;
